<template>
    <DTable
        :items="documentations"
        :fields="fields"
        :header="true"
    >
        <template #example="{item}">
            <td
                v-if="item.link === ''"
                class="text-style"
            >
                {{ item.example }}
            </td>
            <td v-else>
                <a
                    :href="item.link"
                    target="_blank"
                >
                    {{ __('tools.emails.placeholders.help_on_template_logic.link_description') }}
                </a>
            </td>
        </template>
    </DTable>
</template>

<script setup>

import { __ } from '~@/Composables/translation'

defineProps({
    documentations: {
        type: Array,
        default: () => { return [] }
    }
})

const fields = [
    { key: 'value', label: __('tools.emails.placeholders.help_on_template_logic.value') },
    { key: 'example', label: __('tools.emails.placeholders.help_on_template_logic.example') }
]
</script>

<style lang="scss" scoped>
.text-style {
    white-space: pre-wrap;
}
</style>
